import { isEmpty, isNil } from 'lodash';
import React, { memo, useRef } from 'react';

import { parseLatLng } from '../util/parseLatLng';

type Props = {
  items: mapkit.SearchAutocompleteResult[];
  value: string;
  onChange(val: string): void;
  onSelectLocation(coords: mapkit.Coordinate): void;
};

const MapkitAutocomplete = (props: Props) => {
  const { items, value, onChange, onSelectLocation } = props;
  const ref = useRef<HTMLDivElement>(null);

  const handleSelectItem = (item: mapkit.SearchAutocompleteResult) => {
    if (!isNil(item.coordinate)) {
      onSelectLocation(item.coordinate);
      onChange('');
    } else if (!isEmpty(item.displayLines)) {
      // try to parse coordinate
      const potentialCoord = parseLatLng(item.displayLines[0]);
      if (!isNil(potentialCoord)) {
        onSelectLocation(potentialCoord);
        onChange('');
      } else {
        onChange('');
      }
    } else {
      onChange('');
    }
    return;
  };

  return (
    <div ref={ref}>
      <input
        type="text"
        className="input input-md block h-[44px] w-full rounded-md border border-gray-300 bg-white text-gray-600"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search"
        tabIndex={0}
      />
      {items.length > 0 && (
        <div className="top-14 max-h-80 flex-col overflow-y-auto overflow-x-hidden rounded-md bg-white">
          <ul
            className="items-start justify-start bg-white text-start"
            style={{ width: ref.current?.clientWidth }}
          >
            {items.map((item, index) => {
              return (
                <li
                  key={index}
                  tabIndex={index + 1}
                  onClick={() => handleSelectItem(item)}
                  className="w-full cursor-pointer border-b border-b-gray-300 bg-white px-2 py-3 text-start text-sm text-gray-600"
                >
                  {item.displayLines.join(' ')}
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
};

export default memo(MapkitAutocomplete);
